import script from "./admin-navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-navbar.vue?vue&type=script&setup=true&lang=js"

import "./admin-navbar.vue?vue&type=style&index=0&id=7f7baefb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7baefb"]])

export default __exports__